export function deleteFromChildWorkPlaces(
	childs,
	structureExternalId,
	positionGroupExternalId,
	deleteWorkPlaceExternalId
) {
	const updatedChilds = childs.map((child) => {
		// Если узел соответствует заданному structureExternalId
		if (child.externalId === structureExternalId) {
			// Обновляем группы должностей
			const updatedPositionGroups = child.positionGroups
				?.map((group) => {
					if (group.externalId === positionGroupExternalId) {
						// Удаляем рабочее место из группы
						const updatedWorkPlaces = group.workPlaces.filter(
							(workPlace) => workPlace.externalId !== deleteWorkPlaceExternalId
						)

						// Если после удаления рабочих мест не осталось, возвращаем null вместо группы
						if (updatedWorkPlaces.length === 0) {
							return null
						}

						// Находим удалённое рабочее место для корректного перерасчёта долей
						const deletedWorkPlace = group.workPlaces.find(
							(workPlace) => workPlace.externalId === deleteWorkPlaceExternalId
						)

						// Пересчитываем количество ставок (может быть дробным) по оставшимся рабочим местам
						const recalculatedStaffUnitsCount = updatedWorkPlaces.reduce((sum, workPlace) => {
							const units = parseFloat(workPlace.staffUnitsCount)
							return sum + (isNaN(units) ? 0 : units)
						}, 0)

						// Корректируем свободные ставки, вычитая долю удалённого рабочего места (если известна)
						const oldFree = parseFloat(group.staffFreeCount)
						const deletedUnits = deletedWorkPlace ? parseFloat(deletedWorkPlace.staffUnitsCount) : 1
						const updatedStaffFreeCount = Math.max(
							0,
							(isNaN(oldFree) ? 0 : oldFree) - (isNaN(deletedUnits) ? 1 : deletedUnits)
						)

						// Возвращаем обновлённую группу
						return {
							...group,
							workPlaces: updatedWorkPlaces,
							staffUnitsCount: recalculatedStaffUnitsCount, // Пересчитываем количество ставок (может быть дробным)
							staffFreeCount: updatedStaffFreeCount, // Обновляем staffFreeCount с учётом долей
						}
					}
					return group // Остальные группы возвращаем без изменений
				})
				// Убираем группы, которые были помечены как null
				.filter((group) => group !== null)

			// Возвращаем обновлённый узел структуры
			return {
				...child,
				positionGroups: updatedPositionGroups,
			}
		}

		// Обрабатываем вложенные childs рекурсивно
		if (child.childs) {
			return {
				...child,
				childs: deleteFromChildWorkPlaces(
					child.childs,
					structureExternalId,
					positionGroupExternalId,
					deleteWorkPlaceExternalId
				),
			}
		}

		// Если узел не подходит, возвращаем его без изменений
		return child
	})

	return updatedChilds
}
